enum FiberPrepOrderState {
  RESERVE_OPTICAL_ROUTE_IN_PROGRESS = 'RESERVE_OPTICAL_ROUTE_IN_PROGRESS',
  RESERVED = 'RESERVED',
  INSTALLATION_OK = 'INSTALLATION_OK',
  INSTALLATION_KO = 'INSTALLATION_KO',
  ERROR = 'ERROR',
  RESERVED_OPTICAL_ROUTE_OK = 'RESERVED_OPTICAL_ROUTE_OK',
  NO_STATUS = 'NO_STATUS'
}

export default FiberPrepOrderState;
